import { cva } from 'class-variance-authority';
import React from 'react';

import {
  AlertTriangleIcon,
  CheckCircleIcon,
  CheckIcon,
  ClockFastForwardIcon,
  InfoCircleIcon,
  MinusIcon,
} from '@/assets/icons';

// table variants are large, default and small
export const TABLE_HEADER_VARIANTS = cva('[&_tr]:bg-neutral-n3', {
  variants: {
    size: {
      default: 'h-14',
      sm: 'h-10',
      lg: 'h-16',
    },
  },
  defaultVariants: {
    size: 'default',
  },
});

export const TABLE_ROW_VARIANTS = cva('bg-neutral-white text-brand-primary-darkest', {
  variants: {
    size: {
      default: 'h-14',
      sm: 'h-10',
      lg: 'h-16',
    },
  },
  defaultVariants: {
    size: 'default',
  },
});

export const TABLE_CELL_ICON_VARIANTS = cva('', {
  variants: {
    size: {
      default: '[&_*]:size-base-plus',
      sm: '[&_*]:size-base',
      lg: '[&_*]:size-m',
    },
  },
  defaultVariants: {
    size: 'default',
  },
});

export const DEFAULT_STATUS_VARIANT_ICON: Record<string, React.ReactNode> = {
  default: <InfoCircleIcon />,
  todo: <CheckCircleIcon />,
  pending: <ClockFastForwardIcon />,
  doing: <InfoCircleIcon />,
  completed: <CheckIcon />,
  error: <AlertTriangleIcon />,
  cancelled: <MinusIcon />,
};
